export enum JobLevelEndpoints {
  FetchJobLevels = '/job-levels',
}
